import React from 'react';
import huluLogo from '../../_assets/_img/hulu-logo.svg';
import twitter from '../../_assets/_img/twitter-white.svg';
import fb from '../../_assets/_img/fb-white.svg';
import ig from '../../_assets/_img/ig-white.svg';
import './Footer.scss';
const Footer = () => (
  <div className="footer">
    <div className="mobile-footer-all">

    <div className="container">
      <p className="title">Freedom is just the beginning</p>
        {/* <p className="line"></p>
        <a href=""><p className='episodes'>Emi's Journey</p></a> */}
        <p className="line"></p>
        <p className='episodes'>Return Home</p>
    </div>
    <div className="">
      <iframe src="https://player.vimeo.com/video/532379498" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
      <div className="mobile-footer">
        <img className="hmt-logo" src={huluLogo} />
        <div>
        <div className="social-icons">
          <a target="_blank" href="https://twitter.com/HandmaidsOnHulu"><img src={twitter} /></a>
          <a target="_blank" href="https://www.facebook.com/handmaidsonhulu/"><img src={fb} /></a>
          <a target="_blank" href="https://www.instagram.com/handmaidsonhulu/?hl=en"><img src={ig} /></a>
        </div>
          <p><a target="_blank" href="https://twitter.com/handmaidsonhulu?lang=en" target="_blank">@handmaidsonhulu</a></p>
          <p><a target="_blank" href="https://twitter.com/search?q=HandmaidsTale" target="_blank">#HandmaidsTale</a></p>
        </div>
      </div>
    </div>
    </div>

    <div className="desktop-footer ">
      <div className="">
        <div className="panel">
          <p className="big-title">Freedom is just the beginning</p>
          {/* <img className="hmt-logo" src={huluLogo} /> */}
        </div>
        <div className="panel panel--right">
          <div className="lol">
          {/* <p><span className="span">Emi's Journey</span> Read Article</p> */}
          </div>
          <div>
          <p className="span regular-span">Watch the new season of <span className="italics">The Handmaid's Tale</span>, only on Hulu</p>
          <iframe src="https://player.vimeo.com/video/532379498" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          <div className="desktop-social">
            <a target="_blank" href="https://twitter.com/HandmaidsOnHulu"><img src={twitter} /></a>
            <a target="_blank" href="https://www.facebook.com/handmaidsonhulu/"><img src={fb} /></a>
            <a target="_blank" href="https://www.instagram.com/handmaidsonhulu/?hl=en"><img src={ig} /></a>
            <p><a target="_blank" href="https://twitter.com/handmaidsonhulu?lang=en" target="_blank">@handmaidsonhulu</a></p>
            <p><a target="_blank" href="https://twitter.com/search?q=HandmaidsTale" target="_blank">#HandmaidsTale</a></p>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer;